module.exports = __webpack_public_path__ + "img/pilas.950fe057.gif";